<!-- 设备管理 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="option">
        <el-button type="primary" @click="setData(0)">添加充值每升减</el-button>
      </div>
      <el-table
        :data="tableList"
        height="calc(100% - 120px)"
        v-loading="loading"
        :header-cell-style="setTableHeader"
      >
        <el-table-column label="卡类别" prop="cardType"></el-table-column>
        <el-table-column label="卡项" prop="card"></el-table-column>
        <el-table-column label="每减">
          <template slot-scope="scope">
            <div v-if="scope.row.card_type == 0">
              <div v-for="(item, index) in scope.row.ruleData" :key="index">
                规则{{ index + 1 }}
                <div>油品：{{ item.title }} 每升减： {{ item.money }}</div>
                <!-- <div>油品：{{ item.title }}</div>
                <div>每升减： {{ item.money }}</div> -->
              </div>
            </div>
            <div v-else>{{ scope.row.value }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time"></el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-button type="text" @click="setData(1, scope.row)"
              >编辑</el-button
            >
            <el-button type="text" @click="delItem(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--设置充值-->
      <el-dialog
        :title="dialogTitle"
        width="40%"
        :visible.sync="addStatus"
        :show-close="false"
      >
        <el-form :model="formData" ref="formData" label-width="80px">
          <el-form-item label="适用卡项">
            <el-radio-group v-model="formData.card_type" :disabled="is_Status">
              <el-radio :label="0">会员卡</el-radio>
              <el-radio :label="1">加油卡</el-radio>
              <el-radio :label="3">车队卡</el-radio>
            </el-radio-group>
            <div class="selection_box" v-if="formData.card_type == '0'">
              <el-checkbox-group
                v-model="selectLevel"
                :disabled="$route.query.eid !== undefined"
              >
                <el-checkbox
                  v-for="item in vipLevelList"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div class="selection_box" v-if="formData.card_type == '1'">
              <el-checkbox-group
                v-model="selectOilsCard"
                :disabled="$route.query.eid !== undefined"
              >
                <el-checkbox
                  v-for="item in oilsCardList"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div class="selection_box" v-if="formData.card_type == '3'">
              <el-checkbox-group
                v-model="selectCardList"
                :disabled="$route.query.eid !== undefined"
              >
                <el-checkbox
                  v-for="item in cardListCard"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <!-- oilValue -->
          <div v-if="formData.card_type != 0">
            <el-form-item label="每升减">
              <el-input
                type="text"
                v-model="formData.oilValue"
                class="input_Box_medium"
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </div>
          <div v-else>
            <div v-for="(item, index) in formData.value" :key="index">
              <div class="rule" v-if="formData.value.length > 1">
                <div>
                  {{ "规则" + (index + 1) }}
                </div>
                <el-button type="text" @click="delRule(index)">删除</el-button>
              </div>

              <el-form-item label="绑定油品" v-if="formData.card_type == 0">
                <el-select
                  v-model="item.goods_id"
                  multiple
                  placeholder="请选择产品"
                  class="input_Box_medium"
                  @change="changeOil"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="每升减">
                <el-input
                  type="text"
                  v-model="item.money"
                  class="input_Box_medium"
                >
                  <template slot="append">
                    元
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <el-button @click="addRule" v-if="formData.card_type == '0'"
              >添加规则</el-button
            >
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" @click="AddEquip">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  CardConsumeIndex,
  CardConsumeAdd,
  CardConsumeEditor,
  CardConsumeDel
} from "@/api/market";
import { goodsOptions, vipList, listRefule } from "@/api/vip";
import { mapGetters } from "vuex";
import { cardList } from "@/api/motorcade";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {},
  data() {
    return {
      is_Status: false, //false 为添加状态 ture 为编辑状态
      dialogTitle: "价立减",
      vipLevelList: [], //会员等级列表
      selectLevel: [], //选择的会员等级
      oilsCardList: [], //加油卡列表
      selectOilsCard: [], //加油卡列表
      cardListCard: [], //车队卡列表
      selectCardList: [], //车队卡列表
      tableList: [], //列表
      keyword: "",
      page: 1,
      total: 0,
      formData: {
        id: "", //编辑id
        card_type: "",
        oilValue: "", //当为加油卡或者汽油卡的情况下
        value: [
          {
            money: "",
            goods_id: []
          }
        ]
      },
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      editForm: {},
      showEdit: false,
      loading: true,
      loading2: false,
      equipName: "",
      addStatus: false,
      options: [], //关联产品列表
      numberList: [] //充值号列表
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getData();
      this.getipmentList();
    });
    this.numberList = new Array(30)
      .toString()
      .split(",")
      .map(function(item, index) {
        return index + 1 + "号充值";
      });
  },
  methods: {
    // 状态
    setData(type, status = "a") {
      if (type == 0) {
        this.is_Status = false;
        this.dialogTitle = "添加价立减";
      } else {
        this.is_Status = true;
        this.dialogTitle = "编辑价立减";
        console.log("编辑数据", status);
        this.formData.id = status.id;
        this.formData.card_type = status.card_type * 1;
        if (status.card_type == 1) {
          // 加油卡
          this.formData.oilValue = status.value;
          this.selectOilsCard = status.card_ids.split(",");
        } else if (status.card_type == 0) {
          // 会员卡
          this.selectLevel = status.card_ids.split(",");
          let newData = [];
          status.value.forEach(item => {
            let obj = {};
            let goodsAr = item.goods_id.split(",");
            obj.goods_id = goodsAr.map(num => {
              return num * 1;
            });
            obj.money = item.money;
            newData.push(obj);
          });
          this.formData.value = newData;
          console.log("數據", this.formData.value);
        } else {
          // 加油卡
          this.selectCardList = status.card_ids.split(",");
          this.formData.oilValue = status.value;
        }
      }
      this.addStatus = true;
    },
    // 新增规则
    addRule() {
      let obj = {
        goods_id: [],
        money: ""
      };
      this.formData.value.push(obj);
    },
    // 删除规则
    delRule(index) {
      if (index == 0) {
        this.$message.warning("请至少保留一项规则！！");
        return;
      } else {
        this.formData.value.splice(index, 1);
      }
    },
    // 关闭弹窗
    close() {
      this.is_Status = false;
      this.addStatus = false;
      this.formData = {
        id: "",
        card_type: "",
        oilValue: "",
        value: [
          {
            money: "",
            good_id: ""
          }
        ]
      };
    },
    changeOil(val) {
      // console.log("选项", val);
      let arr = [];
      this.formData.value.forEach(item => {
        arr = arr.concat(item.goods_id);
      });
      console.log("数组", arr);
      this.options.forEach(item => {
        item.disabled = arr.includes(item.id) ? true : false;
      });
    },
    getData() {
      var data = {
        token: this.token,
        app_id: this.app_id
      };
      this.$nextTick(function() {
        // 获取会员卡等级列表
        vipList(data).then(res => {
          if (res.code == 200) {
            this.vipLevelList = [];
            res.data.forEach(item => {
              var i = {
                id: String(item.id),
                name: item.name
              };
              this.vipLevelList.push(i);
            });
          }
        });
        // 加油卡列表
        listRefule(data).then(res => {
          if (res.code == 200) {
            this.oilsCardList = [];
            res.result.forEach(item => {
              var i = {
                id: String(item.id),
                name: item.name
              };
              this.oilsCardList.push(i);
            });
          }
        });
        // 车队卡列表
        cardList(data).then(res => {
          console.log(res);
          this.cardListCard = res.result;
          this.total = res.total_num;
        });
        // 油品列表
        goodsOptions(data).then(res => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              this.options = res.data;
              this.options.forEach(item => {
                item.disabled = false;
              });
            } else {
              this.$message.error("暂无数据...");
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      });
    },
    getipmentList() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        name: this.keyword
      };
      CardConsumeIndex(data).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.tableList = res.data;

            this.tableList.forEach(item => {
              // 卡类别
              item.cardType =
                item.card_type == 0
                  ? "会员卡"
                  : item.card_type == 1
                  ? "加油卡"
                  : "车队卡";
              // 卡
              let carArr = [];
              item.user_level.forEach(itemLevel => {
                carArr.push(itemLevel.name);
              });
              item.card = carArr.join(",");
              // value
              item.ruleData = [];
              if (item.card_type == 0) {
                item.value.forEach(valueSon => {
                  let titleArr = [];
                  let valueAll = {}; //title 油品 money 每升减

                  //规则
                  valueSon.goods.forEach(son => {
                    titleArr.push(son.name);
                  });
                  valueAll.title = titleArr.join("|");
                  valueAll.money = valueSon.money;
                  item.ruleData.push(valueAll);
                });
              }
            });

            this.total = res.total_num;
            this.page = res.page;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error("暂无数据....");
          }
        } else {
          this.loading = false;
          this.tableList = [];
          this.$message.error(res.msg);
        }
      });
    },
    //跳页
    handleCurrentChange(p) {
      this.page = p;
      this.getipmentList();
    },
    // 搜索
    search() {
      this.page = 1;
      this.getipmentList();
    },
    // 设置
    AddEquip() {
      this.addStatus = false;
      this.loading2 = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        card_type: this.formData.card_type
      };
      if (this.formData.card_type == 3) {
        if (this.selectCardList.length == 0) {
          this.$message.warning("请选择卡项！！");
          return false;
        }
        data.card_ids = this.selectCardList.join(",");
      } else if (this.formData.card_type == 0) {
        if (this.selectLevel.length == 0) {
          this.$message.warning("请选择卡项！！");
          return false;
        }
        data.card_ids = this.selectLevel.join(",");
      } else {
        if (this.selectOilsCard.length == 0) {
          this.$message.warning("请选择卡项！！");
          return false;
        }
        data.card_ids = this.selectOilsCard.join(",");
      }
      // 規則
      if (this.formData.card_type != 0) {
        data.value = this.formData.oilValue;
      } else {
        data.value = [];
        this.formData.value.forEach(item => {
          let obj = {
            goods_id: item.goods_id.length ? item.goods_id.join(",") : "",
            money: item.money
          };
          data.value.push(obj);
        });
      }
      console.log("传值", data);
      if (!this.is_Status) {
        CardConsumeAdd(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.formData = {
              id: "",
              card_type: "",
              oilValue: "",
              value: [
                {
                  money: "",
                  good_id: ""
                }
              ]
            };
            this.getipmentList();
          } else {
            this.$message.error(res.msg);
          }
          this.loading2 = false;
        });
      } else {
        console.log("编辑提交", this.formData);
        data.id = this.formData.id;
        console.log("编辑提交", data);
        CardConsumeEditor(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.formData = {
              id: "",
              card_type: "",
              oilValue: "",
              value: [
                {
                  money: "",
                  good_id: ""
                }
              ]
            };
            this.getipmentList();
          } else {
            this.$message.error(res.msg);
          }
          this.loading2 = false;
        });
      }
    },
    //删除
    delItem(i) {
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: i
          };
          CardConsumeDel(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.getipmentList();
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch();
    },
    inputName(i) {
      if (i == 1) {
        this.formData.name = isNaN(Number(this.formData.name))
          ? ""
          : this.formData.name;
      } else if (i == 2) {
        this.editForm.name = isNaN(Number(this.editForm.name))
          ? ""
          : this.editForm.name;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../sub_com.scss";
.option {
  width: 100%;
  height: 70px;
  display: flex;
  padding-left: 10px;
  align-items: center;
  background: #ffffff;
}
//
.selection_box {
  margin-top: 10px;
}
// 規則样式
.rule {
  display: flex;
  justify-content: space-between;
  div {
    width: 80px;
    text-align: right;
    padding-right: 12px;
  }
}
// table
.el-table {
  box-shadow: 0 0 3px #f1f1f1;
  padding-left: 10px;
  height: 100%;
}
.add_box {
  box-shadow: 0 0 3px #f1f1f1;
  padding: 20px 20px 0 10px;
  height: 100%;
  .form_line {
    display: flex;
    div {
      margin: 0 10px;
    }
  }
}
.level_img {
  width: 60px;
  height: 60px;
}
//表格中的商品内容
.table_line {
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.input_Box_medium {
  width: 80%;
}
//分页
.Otherpage {
  width: 100%;
  height: 34px;
  line-height: 34px;
  background: #ffffff;
}
.dialog_box {
  margin: 0 50px;
  .bottom {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
